import React from 'react';
import { ShieldCheck } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  icon?: boolean;
}
export function Button({
  children,
  className = '',
  icon = true,
  ...props
}: ButtonProps) {
  return <button className={`btn-primary w-full md:w-auto ${className}`} {...props} data-id="element-45">
      {icon && <ShieldCheck className="w-6 h-6 mr-3" data-id="element-46" />}
      {children}
    </button>;
}